import { RequestProcessorWorker } from './requestProcessorWorker';
export class RequestProcessorWorkerGroup {
    constructor(workerFactory, queryToKey) {
        this.activeQueries = new Map();
        this.workerFactory = workerFactory;
        this.queryToKey = queryToKey;
    }
    subscribe(query, observer) {
        var _a;
        const key = this.queryToKey(query);
        if (!this.activeQueries.get(key)) {
            this.activeQueries.set(key, new RequestProcessorWorker(this.workerFactory(query), () => {
                this.activeQueries.delete(key);
            }));
        }
        (_a = this.activeQueries.get(key)) === null || _a === void 0 ? void 0 : _a.addSubscriber(observer);
    }
    size() {
        return this.activeQueries.size;
    }
}
